enum OrderClientLitigeEntryPoints {
  getCollection = '/api/client-service/order-client-litige/list',
  getCollectionByClient = '/api/sale/client/{uuid}/disputes',
}

export default OrderClientLitigeEntryPoints;
